import * as types from './types';
export default {
  [types.SET_WISHLIST_ITEMS](state, payload) {
    const currentState = state;
    currentState.items = payload.products;
  },

  [types.ADD_WISHLIST_ITEM](state, payload) {
    const currentState = state;
    currentState.items.push(payload);
  },

  [types.DELETE_WISHLIST_ITEM](state, payload) {
    const currentState = state;
    const index = currentState.items.findIndex((_ref) => {
      let {
        reference
      } = _ref;
      return reference === payload;
    });
    currentState.items.splice(index, 1);
  },

  [types.SET_WISHLIST_PRODUCTS](state, payload) {
    const currentState = state;
    currentState.products = payload.products;
  }

};